import { Component } from '@angular/core';

@Component({
  selector: 'lm-home-route',
  standalone: false,
  template: `
    <div>
        <p>Home route for the Angular Soho 4 landmarkUI</p>
    </div>
  `
})
export class LMHomeRouteComponent {

  constructor() {}
}
